module.exports = __webpack_public_path__ + "img/Korzika.cc7f0074.png";